export default {
  Coupon: {
    Title   : 'Coupons | Coupon | Coupons',
    ListView: {
      Button: {
        Add: {
          Title: 'New Coupon',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Edit Coupon',
          Color: 'cyan',
          Icon : 'edit'
        }
      },
      Table: {
        Headers: {
          Id              : '#',
          Name            : 'Name',
          Code            : 'Code',
          Type            : 'Type',
          Discount        : 'Discount',
          UsedCount       : 'Redemptions',
          Customers       : 'Customers',
          CustomerGroups  : 'Customer Groups',
          OrderRestriction: 'Order Type',
          SourceType      : 'Order Source',
          Validity        : 'Validity',
          AutoApply       : 'Auto Apply',
          Status          : 'Status',
          Actions         : ''
        }
      }
    },
    Dialog: {
      Toolbar: {
        Add: {
          Title   : 'New Coupon',
          SubTitle: 'Create New Coupon'
        },
        Edit: {
          Title   : 'Edit Coupon',
          SubTitle: 'Edit Coupon Details'
        },
        Tab: {
          General     : 'General',
          Restrictions: 'Restrictions',
          History     : 'History'
        }
      },

      History: {
        Table: {
          Headers: {
            Id        : '#',
            Customer  : 'Customer',
            Order     : 'Order',
            OrderTotal: 'Total',
            Amount    : 'Discount',
            Date      : 'Date'
          }
        }
      },

      Field: {

        Name: {
          Label: 'Name',
          Hint : 'Coupon Name. eg. Sale 10%',
          Error: {
            Between: 'The name must be between 2 and 128 characters.'
          }
        },
        Code: {
          Label: 'Code',
          Hint : 'Coupon Code. eg. OFFER10, etc.',
          Error: {
            Between: 'The code must be between 2 and 15 characters'
          }
        },

        Type: {
          Title      : 'Discount Type',
          RadioOption: {
            DiscountPercent: 'Discount Percent',
            FixedPrice     : 'Fixed Price'
          }

        },

        Discount: {
          Label: {
            DiscountPercent: '@:Marketing.Coupon.Dialog.Field.Type.RadioOption.DiscountPercent',
            FixedPrice     : '@:Marketing.Coupon.Dialog.Field.Type.RadioOption.FixedPrice'
          },
          Hint : '@:Marketing.Coupon.Dialog.Field.Discount.Label.DiscountPercent or @:Marketing.Coupon.Dialog.Field.Discount.Label.FixedPrice discount',
          Error: {
            Number: 'Must be number'
          }
        },

        OrderRestriction: {
          Title      : 'Order Type',
          RadioOption: {
            All     : 'All',
            Delivery: 'Delivery',
            TakeAway: 'Take Away'
          }
        },

        Redemptions: {
          Label: 'Redemptions',
          Hint : 'The total number of times this coupon can be redeemed. Enter 0 for unlimited redemptions.',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        CustomerRedemptions: {
          Label: 'Customer Redemptions',
          Hint : 'The total number of times this coupon can be redeemed per customer. Enter 0 for unlimited redemptions.',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        MinTotal: {
          Label: 'Minimum total',
          Hint : 'Minimum order total so that the coupon can be used',
          Error: {
            Number: '@:Marketing.Coupon.Dialog.Field.Discount.Error.Number'
          }
        },

        Status: {
          Title: 'Status'
        },

        AutoApply: {
          Title: 'Auto Apply'
        },

        Validity: {
          Title : 'Validity',
          Toggle: {
            Always: {
              Title: 'Always'
            },
            DateTime: {
              Title  : 'Date / Time',
              Options: {
                TwentyFourHours: '24 Hours',
                Custom         : 'Custom'
              }
            },
            Period: {
              Title: 'Period'
            },
            Repeat: {
              Title  : 'Repeat',
              Options: {
                TwentyFourHours: '@:Marketing.Coupon.Dialog.Field.Validity.Toggle.DateTime.Options.TwentyFourHours',
                Custom         : '@:Marketing.Coupon.Dialog.Field.Validity.Toggle.DateTime.Options.Custom'
              }
            }
          }
        }

      },

      Message: {
        Save: {
          Success: 'Coupon was successfully saved.'
        },
        Update: {
          Success: 'Coupon was successfully updated.'
        }
      }
    }
  },

  Tag: {
    Title   : 'Marketing Tags | Marketing Tag | Marketing Tags',
    ListView: {
      Button: {
        Add: {
          Title: 'New Marketing Tag',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Edit Marketing Tag',
          Color: 'cyan',
          Icon : 'edit'
        },
        Delete: {
          Title: 'Delete Marketing Tag',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Name',
          CreatedAt: 'Date',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-email-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Marketing Tags',
          Subtitle : '',
          Button   : {
            Title: 'New Marketing Tag',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : []
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Delete Marketing Tag?',
        Content: 'Are you sure you want to delete marketing tag "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'The deletion is final and the process is irreversible'
      }
    },
    Dialog: {
      EditTag: {
        Toolbar: {
          Add: {
            Title   : 'Marketing Tag',
            SubTitle: 'Create',
            Icon    : 'mdi-tag-text-outline'
          },
          Edit: {
            Title   : 'Marketing Tag',
            SubTitle: 'Edit',
            Icon    : 'mdi-tag-text-outline'
          }
        },
        Message: {
          Save: {
            Success: 'The marketing tag was successfully saved.'
          },
          delete: {
            Success: 'The marketing tag was successfully deleted.'
          }
        },
        Field: {
          Name: {
            Label: 'Name',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You need to fill in name',
              Between : 'Name must be from 2 to 128 characters'
            }
          }
        }
      }
    }
  },

  Email: {
    Title   : 'Email Campaigns | Email Campaign | Email Campaigns',
    ListView: {
      Button: {
        ViewTemplate: {
          Title: 'Email Templates',
          Color: 'primary',
          Icon : 'mdi-view-compact-outline'
        },
        Add: {
          Title: 'New Email Campaign',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Edit Email Campaign',
          Color: 'cyan',
          Icon : 'edit'
        },
        Duplicate: {
          Title: 'Duplicate Email Campaign',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Delete: {
          Title: 'Delete Email Campaign',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id         : '#',
          Name       : 'Name',
          Groups     : 'Groups',
          Tags       : 'Tags',
          Status     : 'Status',
          Sent       : 'Sent',
          Delivered  : 'Delivered',
          Opened     : 'Opened',
          Clicked    : 'Clicked',
          SendAt     : 'Send At',
          ScheduledAt: 'Scheduled At',
          CreatedAt  : 'Created At',
          Actions    : ''
        },
        NoData: {
          Icon     : 'mdi-email-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Email Campaigns',
          Subtitle : '',
          Button   : {
            Title: 'New Campaign',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Manage marketing emails quickly and easily',
              'No-code editor for easy creation',
              'Email for newsletters, coupons, offers and more'
            ]
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Delete Campaign;',
        Content: 'Are you sure you want to delete campaign "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'The deletion is final and the process is irreversible'
      }
    },
    Dialog: {
      EditCampaign: {
        Toolbar: {
          Title   : 'Email Campaign',
          SubTitle: 'Edit',
          Icon    : 'mdi-email-fast'
        },
        Message: {
          Save: {
            Success: 'The campaign was successfully saved.'
          },
          Send: {
            Success: 'The campaign was successfully sent.'
          }
        },
        ConfirmSend: {
          Title  : 'Send Campaign?',
          Content: 'Are you sure you want to send the campaign?'
        },
        Section: {
          Audience: '1. Audience',
          Sender  : '2. Sender',
          Message : '3. Message',
          Delivery: '4. Delivery'
        },
        Field: {
          Name: {
            Label: 'Name',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a name',
              Between : 'Name must be from 2 to 128 characters'
            }
          },
          Subject: {
            Label: 'Subject',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a subject',
              Between : 'Το θέμα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          },
          Tag: {
            Label: 'Tags',
            Hint : '',
            Icon : ''
          },
          GroupIncludes: {
            Label: 'Include Customer Group',
            Hint : '',
            Icon : ''
          },
          GroupExcludes: {
            Label: 'Exclude Customer Group',
            Hint : '',
            Icon : ''
          },
          SenderName: {
            Label: 'Sender Name',
            Hint : '',
            Icon : ''
          },
          SenderEmail: {
            Label: 'Sender Email',
            Hint : '',
            Icon : ''
          },
          ScheduledAt: {
            LabelNow      : 'Now',
            LabelScheduled: 'Schedule',
            Hint          : '',
            Icon          : '',
            Error         : {
              RequiredDate: 'You must select date',
              RequiredTime: 'You must select time'
            }
          }
        }
      },
      AddCampaign: {
        Toolbar: {
          Title   : 'Email Campaign',
          SubTitle: 'Create',
          Icon    : 'mdi-email-fast'
        }
      },
      PreviewTemplate: {
        Toolbar: {
          Title   : 'Email Template',
          SubTitle: 'Preview',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'Email Template',
          SubTitle: 'Edit',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'The template was successfully saved.'
          }
        },
        Field: {
          Title: {
            Label: 'Name',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a name',
              Between : 'Name must be from 2 to 128 characters'
            }
          },
          Subject: {
            Label: 'Subject',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a subject',
              Between : 'The subject must be from 2 to 256 characters'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'Email Template',
          SubTitle: 'Create',
          Icon    : 'mdi-email-newsletter'
        }
      },
      Templates: {
        Toolbar: {
          Title   : 'Email Templates',
          SubTitle: 'Select Email Template',
          Icon    : 'mdi-email-newsletter'
        },
        Button: {
          New: {
            Title: 'New Template',
            Color: 'green',
            Icon : 'mdi-application-edit-outline'
          },
          Edit: {
            Title: 'Edit Template',
            Color: 'blue',
            Icon : 'mdi-application-cog-outline'
          },
          Preview: {
            Title: 'View Template',
            Color: 'blue-grey',
            Icon : 'mdi-file-find'
          },
          Select: {
            Title: 'Select Template',
            Color: 'green',
            Icon : 'mdi-file-code-outline'
          },
          Delete: {
            Title: 'Delete Template',
            Color: 'red',
            Icon : 'mdi-close-circle-outline'
          }
        },
        Blank: {
          Title  : 'Blank Template',
          Subject: 'Start with a blank template'
        },
        NoDataEdit: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Email Templates',
          Subtitle : 'There are no email templates yet',
          Button   : {
            Title: 'New Template',
            Color: 'primary',
            Icon : 'add_box'
          }
        },
        NoDataSelect: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'Email Templates',
          Subtitle : 'There are no email templates yet',
          Button   : {
            Title: 'New Template',
            Color: 'primary',
            Icon : 'add_box',
            Block: true
          },
          ButtonCampaign: {
            Title: 'New campaign without a template',
            Color: 'green',
            Icon : 'add_box'
          }
        }
      }
    }
  },

  Sms: {
    Title   : 'SMS Campaigns | SMS Campaign | SMS Campaigns',
    ListView: {
      Button: {
        ViewTemplate: {
          Title: 'SMS Templates',
          Color: 'primary',
          Icon : 'mdi-view-compact-outline'
        },
        Add: {
          Title: 'New SMS Campaign',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Edit SMS Campaign',
          Color: 'cyan',
          Icon : 'edit'
        },
        Duplicate: {
          Title: 'Duplicate SMS Campaign',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Delete: {
          Title: 'Delete SMS Campaign',
          Color: 'red',
          Icon : 'close'
        }
      },
      Table: {
        Headers: {
          Id         : '#',
          Name       : 'Name',
          Groups     : 'Groups',
          Tags       : 'Tags',
          Status     : 'Status',
          Sent       : 'Sent',
          Delivered  : 'Delivered',
          Opened     : 'Opened',
          Clicked    : 'Clicked',
          SendAt     : 'Send At',
          ScheduledAt: 'Scheduled At',
          CreatedAt  : 'Created At',
          Actions    : ''
        },
        NoData: {
          Icon     : 'mdi-message-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'SMS Campaigns',
          Subtitle : '',
          Button   : {
            Title: 'New Campaign',
            Color: 'primary',
            Icon : 'add_box'
          },
          ButtonActivate: {
            Title: 'Activate',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Manage marketing SMS quickly and easily',
              'No-code editor for easy creation',
              'SMS for newsletters, coupons, offers and more'
            ]
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Delete Campaign?',
        Content: 'Are you sure you want to delete campaign "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'The deletion is final and the process is irreversible'
      }
    },
    Dialog: {
      EditCampaign: {
        Toolbar: {
          Title   : 'SMS Campaign',
          SubTitle: 'Edit',
          Icon    : 'mdi-email-fast'
        },
        Message: {
          Save: {
            Success: 'The campaign was successfully saved.'
          },
          Send: {
            Success: 'The campaign was successfully sent.'
          }
        },
        ConfirmSend: {
          Title  : 'Send Campaign?',
          Content: 'Are you sure you want to send the campaign?'
        },
        Section: {
          Audience: '1. Audience',
          Sender  : '2. Sender',
          Message : '3. Message',
          Delivery: '4. Delivery'
        },
        Field: {
          Name: {
            Label: 'Name',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a name',
              Between : 'Name must be from 2 to 128 characters'
            }
          },
          Body: {
            Label: 'Message',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter the message'
            }
          },
          Tag: {
            Label: 'Tags',
            Hint : '',
            Icon : ''
          },
          GroupIncludes: {
            Label: 'Include Customer Group',
            Hint : '',
            Icon : ''
          },
          GroupExcludes: {
            Label: 'Exclude Customer Group',
            Hint : '',
            Icon : ''
          },
          SenderName: {
            Label: 'Sender Name',
            Hint : '',
            Icon : ''
          },
          ScheduledAt: {
            LabelNow      : 'Now',
            LabelScheduled: 'Schedule',
            Hint          : '',
            Icon          : '',
            Error         : {
              RequiredDate: 'You must select date',
              RequiredTime: 'You must select time'
            }
          },
          RespectQuietHours: {
            Label  : 'Respect Quiet Hours',
            Tooltip: 'Indicates if the SMS should respect the quiet hours. Quiet Hours are set by default to 23.00 - 08.00 and 14.00-17.00 destination local time.'
          },
          Info: {
            Sms       : 'SMS',
            Characters: 'Characters | Character | Characters',
            Encoding  : 'Encoding'
          }
        }
      },
      AddCampaign: {
        Toolbar: {
          Title   : 'SMS Campaign',
          SubTitle: 'Create',
          Icon    : 'mdi-email-fast'
        }
      },
      PreviewTemplate: {
        Toolbar: {
          Title   : 'SMS Template',
          SubTitle: 'Preview',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'SMS Template',
          SubTitle: 'Edit',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'The template was successfully saved.'
          }
        },
        Field: {
          Title: {
            Label: 'Name',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a name',
              Between : 'Name must be from 2 to 128 characters'
            }
          },
          Body: {
            Label: 'Message',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'You must enter a message',
              Between : 'The message must be from 2 to 160 characters'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'SMS Template',
          SubTitle: 'Create',
          Icon    : 'mdi-email-newsletter'
        }
      },
      Templates: {
        Toolbar: {
          Title   : 'SMS Templates',
          SubTitle: 'Select SMS Template',
          Icon    : 'mdi-email-newsletter'
        },
        Button: {
          New: {
            Title: 'New Template',
            Color: 'green',
            Icon : 'mdi-application-edit-outline'
          },
          Edit: {
            Title: 'Edite Template',
            Color: 'blue',
            Icon : 'mdi-application-cog-outline'
          },
          Preview: {
            Title: 'View Template',
            Color: 'blue-grey',
            Icon : 'mdi-file-find'
          },
          Select: {
            Title: 'Select Template',
            Color: 'green',
            Icon : 'mdi-file-code-outline'
          },
          Delete: {
            Title: 'Delete Template',
            Color: 'red',
            Icon : 'mdi-close-circle-outline'
          }
        },
        Blank: {
          Title  : 'Blank Template',
          Subject: 'Start with a blank template'
        },
        NoDataEdit: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'SMS Templates',
          Subtitle : 'There are no SMS templates yet',
          Button   : {
            Title: 'New Template',
            Color: 'primary',
            Icon : 'add_box'
          }
        },
        NoDataSelect: {
          Icon     : 'mdi-email-newsletter',
          IconColor: 'light-blue lighten-3',
          Title    : 'SMS Templates',
          Subtitle : 'There are no SMS templates yet',
          Button   : {
            Title: 'New Template',
            Color: 'primary',
            Icon : 'add_box',
            Block: true
          },
          ButtonCampaign: {
            Title: 'New campaign without a template',
            Color: 'green',
            Icon : 'add_box'
          }
        }
      }
    }
  },

  Push: {
    Title   : 'Push Notification Campaigns | Push Notification Campaign | Push Notification Campaigns',
    ListView: {
      Button: {
        Add: {
          Title: 'New Push Notification Campaign',
          Color: 'primary',
          Icon : 'add_box'
        },
        Edit: {
          Title: 'Edit Push Notification Campaign',
          Color: 'cyan',
          Icon : 'edit'
        }
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Name',
          Groups   : 'Groups',
          Status   : 'Status',
          Total    : 'Total',
          Delivered: 'Delivered',
          Ctr      : 'CTR',
          SendAt   : 'Send At',
          CreatedAt: 'Created At',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-bell-badge-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Push Notification Campaigns',
          Subtitle : '',
          Button   : {
            Title: 'New Campaign',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : [
              'Manage marketing Push Notification quickly and easily',
              'No-code editor for easy creation',
              'Push Notification for newsletters, coupons, offers and more'
            ]
          }
        }
      }
    }
  },

  Print: {
    Title   : 'Πρότυπα Εκτυπώσεων | Πρότυπο Εκτυπώσεων | Πρότυπα Εκτυπώσεων',
    ListView: {
      Button: {
        Add: {
          Title: 'Νέο Πρότυπο',
          Color: 'green',
          Icon : 'mdi-application-edit-outline'
        },
        Edit: {
          Title: 'Επεξεργασία Προτύπου',
          Color: 'blue',
          Icon : 'mdi-application-cog-outline'
        },
        Duplicate: {
          Title: 'Αντιγραφή Προτύπου',
          Color: 'orange',
          Icon : 'mdi-content-copy'
        },
        Preview: {
          Title: 'Προβολή Προτύπου',
          Color: 'blue-grey',
          Icon : 'mdi-file-find'
        },
        Delete: {
          Title: 'Διαγραφή Προτύπου',
          Color: 'red',
          Icon : 'mdi-close-circle-outline'
        }
      },
      Tab: {
        Tab1: 'Πρότυπο',
        Tab2: 'Δυναμικά Πεδία'
      },
      Table: {
        Headers: {
          Id       : '#',
          Name     : 'Όνομα',
          Products : 'Προϊόντα',
          CreatedAt: 'Ημ/νία',
          Actions  : ''
        },
        NoData: {
          Icon     : 'mdi-email-fast-outline',
          IconColor: 'light-blue lighten-3',
          Title    : 'Καμπάνιες Email',
          Subtitle : '',
          Button   : {
            Title: 'Νέο Πρότυπο',
            Color: 'primary',
            Icon : 'add_box'
          },
          Bullets: {
            Icon     : 'mdi-check-circle',
            IconColor: 'blue',
            Items    : []
          }
        }
      },
      ConfirmDeleteDialog: {
        Title  : 'Διαγραφή Προτύπου;',
        Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το πρότυπο "<span class="font-weight-light font-italic">{title}</span>";',
        Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
      }
    },
    Dialog: {
      PreviewTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Προεπισκόπηση',
          Icon    : 'mdi-email-newsletter'
        }
      },
      EditTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Επεξεργασία',
          Icon    : 'mdi-email-newsletter'
        },
        Message: {
          Save: {
            Success: 'Το πρότυπο αποθηκεύτηκε επιτυχώς.'
          }
        },
        Field: {
          Title: {
            Label: 'Όνομα',
            Hint : '',
            Icon : '',
            Error: {
              Required: 'Πρέπει να συμπληρώσετε όνομα',
              Between : 'Το όνομα πρέπει να είναι από 2 έως 128 χαρακτήρες'
            }
          }
        }
      },
      AddTemplate: {
        Toolbar: {
          Title   : 'Πρότυπο',
          SubTitle: 'Δημιουργία',
          Icon    : 'mdi-email-newsletter'
        }
      }
    }
  },

  Campaign: {
    Status: {
      UNKNOWN: {
        Id   : 'UNKNOWN',
        Name : 'UNKNOWN',
        Color: 'grey'
      },
      QUEUED: {
        Id   : 'QUEUED',
        Name : 'QUEUED',
        Color: 'amber'
      },
      DRAFT: {
        Id   : 'DRAFT',
        Name : 'DRAFT',
        Color: 'blue-grey'
      },
      SCHEDULED: {
        Id   : 'SCHEDULED',
        Name : 'SCHEDULED',
        Color: 'indigo'
      },
      DELIVERED: {
        Id   : 'DELIVERED',
        Name : 'DELIVERED',
        Color: 'green'
      },
      SENT: {
        Id   : 'SENT',
        Name : 'SENT',
        Color: 'light-green'
      }
    }
  }
}
